import { useEffect } from "react";

const SITE = "https://marsilyabet1.com";
const TITLE = "Marsilya Bet — Slot, Canlı Casino ve Orijinal Oyunlar";
const DESC =
  "Marsilya Bet (marsilya bet): güvenilir online casino ve bahis sitesi. Slot, canlı casino, Marsilya orijinal oyunları, hızlı yatırım ve 7/24 destek.";

function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/** marsilyabet1.com — “marsilya bet” odaklı temel SEO etiketleri */
const SiteSeo = () => {
  useEffect(() => {
    const host = window.location.hostname.toLowerCase();
    if (host === "marsilya.bet" || host === "www.marsilya.bet") {
      document.title = "Yönlendirme";
      setMeta("robots", "noindex, nofollow");
      return;
    }
    document.title = TITLE;
    setMeta("description", DESC);
    setMeta("keywords", "marsilya bet, marsilyabet, marsilya casino, marsilya slot, canlı casino, online bahis");
    setMeta("robots", "index, follow, max-image-preview:large");
    setLink("canonical", `${SITE}${window.location.pathname === "/" ? "" : window.location.pathname}`);
    setMeta("og:title", TITLE, "property");
    setMeta("og:description", DESC, "property");
    setMeta("og:url", SITE, "property");
    setMeta("og:type", "website", "property");
    setMeta("og:locale", "tr_TR", "property");
    setMeta("og:site_name", "Marsilya Bet", "property");
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", TITLE);
    setMeta("twitter:description", DESC);
  }, []);

  return null;
};

export default SiteSeo;
